import { formatDate, WindowLoader } from 'medere-ui-framework';
import { defaultProfessional, DigitalRpForHistoryDTO, PatientRecordDTO, Professional, FileDTO } from '../../../../interface/interface';
import GeneralRecipeViewCard, { addLineBreaksAndStippling } from '../../Components/GeneralRecipeViewCard';
import './RecipeHistoryTab.scss';
import { useState, useEffect } from 'react';
import { loadDigitalRpHistory, getPatientData, loadProfessionalByMedereEntity, loadDigitalRpFile } from '../../../../services/digitalRPservice';

const RecipeHistoryTab = (params: { setOpenSendModal: (open: boolean) => void, setDigitalRpId: (digitalRpId: number) => void, setDigitalRpFiles: (digitalRpFiles: FileDTO) => void, setSelectedPatient: (patient: PatientRecordDTO|null) => void, professional: Professional, patientInput: string, setProfessional: (professional: Professional) => void, datePrescribed:Date, setDatePrescribed: (dp: Date) => void }) => {
    const { setOpenSendModal, setDigitalRpId, setDigitalRpFiles, setSelectedPatient, professional, patientInput, datePrescribed, setDatePrescribed } = params
    const setProfessional = params.setProfessional
    const [completedRecipes, setCompletedRecipes] = useState<DigitalRpForHistoryDTO[]|null>();

    const [isMobile, setisMobile] = useState(window.innerWidth < 700)
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setisMobile(window.innerWidth < 700);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (professional.professionaid >= 0)
            loadHistoryRecipes();
    }, [patientInput, professional])

    const loadProfessional = async (professionalId: number) => {
        if ((professionalId && professionalId > 0) && professional.professionaid !== professionalId) {
            try {
                const loadedProfessional: Professional = await loadProfessionalByMedereEntity(professionalId);
                setProfessional(loadedProfessional);
            } catch (error) {
                console.error('Error: ', error);
                setProfessional(defaultProfessional);
            }
        }
    };
    const loadHistoryRecipes = async () => {
        setLoading(true)
        let recipesFromHistory: DigitalRpForHistoryDTO[]|null;
        if (professional === null || professional.professionaid <= 0) {
            // Keep history scoped to a concrete professional only.
            setCompletedRecipes([]);
            setLoading(false);
            return;
        }

        recipesFromHistory = await loadDigitalRpHistory(professional.professionaid, patientInput)
            .then((res) => {
                return res
            })
            .catch((error) => {
                console.error('Error: ', error);
                return null;
            });
        setCompletedRecipes(recipesFromHistory);
        setLoading(false)
    };

    const showCompletedRecipes = () => (
        completedRecipes?.map((recipe, index) => renderCompleteRecipeContent(recipe, index))
    );

    const renderCompleteRecipeContent = (recipe: DigitalRpForHistoryDTO, index:number) => (
        <GeneralRecipeViewCard
            key={index}
            title={<p style={{ fontWeight: 600 }}>{recipe.patientfullname}</p>}
            detail={addLineBreaksAndStippling(recipe.medicineprescribeddescription, true)}
            detail2={formatDate(recipe.dateprescribed)}
            onClick={() => {

                const loadFile = async () => {
                    const r = await loadDigitalRpFile(recipe).then((res) => {return res});
                    
                    loadPatientInformation(recipe.patientid);
                    setDigitalRpId(recipe.digitalrpid)
                    setDigitalRpFiles({pdfFileName: recipe.pdfpath, encodedPdf: r.pdffile})
                    setOpenSendModal(true)
                    loadProfessional(recipe?.professionalid)
                    params.setDatePrescribed(recipe.dateprescribed)
                };


                const loadPatientInformation = async (patientid: number) => {
                    const patient: PatientRecordDTO|null = await getPatientData(patientid)
                        .then((res) => {
                            return res
                        })
                        .catch((error) => {
                            console.error('Error: ', error);
                            return null;
                        });
                    setSelectedPatient(patient);
                };

                loadFile()
            }}
            backgroundColor='#EAEFEE'
            titleColor='#009688'
        />
    );

    return (
        <div className="recipe-history-tab">
            {isMobile ?
                showCompletedRecipes()
                :
                <div style={{
                    display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px',
                    alignItems: 'start' //hace falta para que no se habran los del costado
                }}>
                    {showCompletedRecipes()}
                </div>
            }
            <WindowLoader showLoader={loading} className='whiteSpinner' />
        </div>
    );
};

export default RecipeHistoryTab;
